module.exports = __webpack_public_path__ + "static/media/online-course-platform.7ce7f972.png";